export enum Lane {
  Top = 'top',
  Jungle = 'jungle',
  Mid = 'mid',
  Bot = 'bot',
}
